import axiosInstance from "../../utils/axios";

export const getDetailsBlog = async (blogId) => {
  const response = await axiosInstance.get(`/blogs/${blogId}`);
  return response.data;
};


